import { Box, useMediaQuery, useTheme } from "@mui/material"
import { DESKTOP_BREAKPOINT } from "~/common/constants/layout-constants"
import NumberField from "~/components/number-field/NumberField"
import NumberSpinner from "~/components/number-field/NumberSpinner"

export const NumberFieldOrSpinner = ({isDesktop: isDesktopOverride, showLabel, ...props}) => {
  const theme = useTheme()
  const isDefaultDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_BREAKPOINT))
  const isDesktop = isDesktopOverride ?? isDefaultDesktop

  if (isDesktop) {
    return <NumberField {...props} />
  }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        '& .MuiOutlinedInput-root': {
          height: '32px',
        },
        '& .MuiInputBase-input': {
          minWidth: '20px',
        },
        '& .MuiButton-root': {
          height: '32px',
          minHeight: '32px',
        },
        // Hide or shrink the label/scrub area
        '& .MuiFormLabel-root': {
          display: showLabel ? 'block' : 'none',
          fontSize: '0.75rem',
        },
      }}
    >
      <NumberSpinner size='small' {...props}/>
    </Box>
  )
}
